import { jsx as e, jsxs as h } from "@emotion/react/jsx-runtime";
import { Body as t } from "./subComponents/Body/Body.js";
import { Cell as f } from "./subComponents/Cell/Cell.js";
import { Header as n } from "./subComponents/Header/Header.js";
import { HeaderCell as p } from "./subComponents/HeaderCell/HeaderCell.js";
import { HeaderRow as s } from "./subComponents/HeaderRow/HeaderRow.js";
import { Row as w } from "./subComponents/Row/Row.js";
import { SelectBar as x } from "./subComponents/SelectBar/SelectBar.js";
import { SkeletonRows as b } from "./subComponents/SkeletonRows/SkeletonRows.js";
import { StyledTable as c } from "./Table.styled.js";
import { useTableContext as O, TableProvider as T } from "./TableContext.js";
const C = ({
  selectable: o = !1,
  children: d,
  columns: i,
  loading: m,
  ref: a
}) => /* @__PURE__ */ e(T, { selectable: o, children: /* @__PURE__ */ h(c, { ref: a, children: [
  /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(s, { hasSelectAllColumn: o, children: i.map((r, l) => /* @__PURE__ */ e(p, { isOrdered: r.isOrdered, orderDirection: r.orderDirection, onOrder: r.onOrder, width: r.width, minWidth: r.minWidth, maxWidth: r.maxWidth, info: r.info, children: r.label }, `header-column-${l}`)) }) }),
  m ? /* @__PURE__ */ e(t, { children: /* @__PURE__ */ e(b, { selectable: o, rows: 5, cols: i.length }) }) : d
] }) }), A = Object.assign(C, {
  Body: t,
  Row: w,
  Cell: f,
  useTableContext: O,
  SelectBar: x
});
export {
  C as BaseTable,
  A as Table
};
